export default {"src":"/_next/static/media/bm.91c2b1d9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};